import { render, staticRenderFns } from "./buyShebei.vue?vue&type=template&id=53936179&scoped=true&"
import script from "./buyShebei.vue?vue&type=script&lang=js&"
export * from "./buyShebei.vue?vue&type=script&lang=js&"
import style0 from "./buyShebei.vue?vue&type=style&index=0&id=53936179&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53936179",
  null
  
)

export default component.exports